import { modelsv2, makeEmptyTransactionSigner } from "algosdk";
import { increaseBudgetBaseCost, increaseBudgetIncrementCost } from "../constants";
export const SIMULATE_PARAMS = {
    allowMoreLogging: true,
    allowUnnamedResources: true,
    extraOpcodeBudget: 130013,
    fixSigners: true,
    allowEmptySignatures: true,
};
const simulateRequest = new modelsv2.SimulateRequest({
    txnGroups: [],
    ...SIMULATE_PARAMS,
});
/* Utility to increase the budget of a transaction group if needed.
 * Simulates and returns undefined if we are under budget, otherwise returns a new builder with an increaseBudget call prepended.
 */
export async function getIncreaseBudgetBuilder(builder, newBuilderFactory, sender, signer, algod) {
    // maxFee/coverAppCallInnerTransactionFees does not work with builder.simulate() #algokit
    // increase first txn's fee so we do not fail because of fees
    // get atc & modify the first txn fee (need to clone to make txns mutable)
    const atc = (await (await builder.composer()).build()).atc.clone();
    // @ts-ignore private and readonly
    atc.transactions[0].txn.fee = 543210n;
    // we also need to replace signers with empty signers for simulation
    // otherwise end users would be prompted to sign for this
    // @ts-ignore private and readonly
    atc.transactions = atc.transactions.map((t) => {
        t.signer = makeEmptyTransactionSigner();
        return t;
    });
    const { simulateResponse: { txnGroups: [{ txnResults, appBudgetConsumed = 0 }], }, } = await atc.simulate(algod, simulateRequest);
    // intentionally doing opup even if there is a failure
    // returning early on failureMessage would obscure the actual failure
    // behind out of budget errors in some cases
    // get existing budget: 700 per top-level app call + 700 per inner app call
    // (non-appl txns - e.g. payments in the group - and non-appl inner txns add no budget)
    // NOTE only goes 1 level deep in itxns
    const numAppCalls = txnResults.reduce((acc, { txnResult }) => {
        if (txnResult?.txn.txn.type !== "appl")
            return acc;
        const innerAppCalls = (txnResult.innerTxns ?? []).filter((t) => t.txn.txn.type === "appl").length;
        return acc + 1 + innerAppCalls;
    }, 0);
    let existingBudget = 700 * numAppCalls;
    // budget is OK, returning
    if (appBudgetConsumed <= existingBudget)
        return;
    existingBudget += 700 - increaseBudgetBaseCost; // add 700 for increaseBudget, removing its base cost
    const itxnBudgetNeeded = appBudgetConsumed - existingBudget; // budget to create in itxns
    const itxns = Math.max(0, Math.ceil(itxnBudgetNeeded / (700 - increaseBudgetIncrementCost))); // base cost - no iterations
    const increaseBudgetArgs = {
        args: { itxns },
        extraFee: (itxns * 1000).microAlgo(),
        maxFee: ((itxns + 1) * 1000).microAlgo(),
        note: getNonce().toString(),
        sender,
        signer,
    };
    return newBuilderFactory().increaseBudget(increaseBudgetArgs);
}
function getNonce() {
    return Math.floor(Math.random() * 100_000_000);
}
